// @ts-nocheck: converted from JS

import DataTables from '@/components/Studies/DataTables/Create';

export default DataTables;
